export default __webpack_public_path__ + "static/media/products_512.931ea65e.jpg";